module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "toc-head"
  }, [_vm._v("Table of Contents")]), _vm._v(" "), _c('div', {
    staticClass: "toc_fm"
  }, [_c('p', {
    staticClass: "toc_fm"
  }, [_c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106915_epub_cvi",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cover")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "d14be04baee4e-d1e230"
    }
  }), _c('p', {
    staticClass: "toc_fm"
  }, [_c('a', {
    attrs: {
      "id": "d14be04baee4e-d1e230"
    }
  }), _c('a', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106915_epub_alb"
    }
  }, [_vm._v("A Selection of Recent Titles by Marjorie Eccles")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "d14be04baee4e-d1e261"
    }
  }), _c('p', {
    staticClass: "toc_fm"
  }, [_c('a', {
    attrs: {
      "id": "d14be04baee4e-d1e261"
    }
  }), _c('a', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106915_epub_tp"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "d57fe3f3d004d-d1e32"
    }
  }), _c('p', {
    staticClass: "toc_fm"
  }, [_c('a', {
    attrs: {
      "id": "d57fe3f3d004d-d1e32"
    }
  }), _c('a', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106915_epub_cop"
    }
  }, [_vm._v("Copyright")])])]), _c('div', {
    staticClass: "toc_body"
  }, [_c('div', {
    staticClass: "toc_part"
  }, [_c('a', {
    attrs: {
      "id": "d14be04baee4e-d1e270"
    }
  }), _c('p', {
    staticClass: "toc_part"
  }, [_c('a', {
    attrs: {
      "id": "d14be04baee4e-d1e270"
    }
  }), _c('a', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106915_epub_part001"
    }
  }, [_vm._v("Part One")])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "d14be04baee4e-d1e273"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "d14be04baee4e-d1e273"
    }
  }), _c('a', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106915_epub_chap001"
    }
  }, [_vm._v("Chapter One")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "d14be04baee4e-d1e325"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "d14be04baee4e-d1e325"
    }
  }), _c('a', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106915_epub_chap002"
    }
  }, [_vm._v("Chapter Two")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "d14be04baee4e-d1e349"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "d14be04baee4e-d1e349"
    }
  }), _c('a', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106915_epub_chap003"
    }
  }, [_vm._v("Chapter Three")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "d14be04baee4e-d1e424"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "d14be04baee4e-d1e424"
    }
  }), _c('a', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106915_epub_chap004"
    }
  }, [_vm._v("Chapter Four")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_part"
  }, [_c('a', {
    attrs: {
      "id": "d14be04baee4e-d1e461"
    }
  }), _c('p', {
    staticClass: "toc_part"
  }, [_c('a', {
    attrs: {
      "id": "d14be04baee4e-d1e461"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106915_epub_part002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Two")])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "d14be04baee4e-d1e464"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "d14be04baee4e-d1e464"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106915_epub_chap005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Five")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "d14be04baee4e-d1e555"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "d14be04baee4e-d1e555"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106915_epub_chap006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Six")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "d14be04baee4e-d1e642"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "d14be04baee4e-d1e642"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106915_epub_chap007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Seven")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "d14be04baee4e-d1e790"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "d14be04baee4e-d1e790"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106915_epub_chap008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Eight")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "d14be04baee4e-d1e957"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "d14be04baee4e-d1e957"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106915_epub_chap009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Nine")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "d14be04baee4e-d1e1038"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "d14be04baee4e-d1e1038"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106915_epub_chap010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Ten")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "d14be04baee4e-d1e1149"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "d14be04baee4e-d1e1149"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106915_epub_chap011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Eleven")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "d14be04baee4e-d1e1253"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "d14be04baee4e-d1e1253"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106915_epub_chap012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twelve")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "d14be04baee4e-d1e1508"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "d14be04baee4e-d1e1508"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106915_epub_chap013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Thirteen")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "d14be04baee4e-d1e1665"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "d14be04baee4e-d1e1665"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106915_epub_chap014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Fourteen")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "d14be04baee4e-d1e1901"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "d14be04baee4e-d1e1901"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106915_epub_chap015",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Fifteen")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "d14be04baee4e-d1e2037"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "d14be04baee4e-d1e2037"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106915_epub_chap016",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Sixteen")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_part"
  }, [_c('a', {
    attrs: {
      "id": "d14be04baee4e-d1e2084"
    }
  }), _c('p', {
    staticClass: "toc_part"
  }, [_c('a', {
    attrs: {
      "id": "d14be04baee4e-d1e2084"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106915_epub_part003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Three")])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "d14be04baee4e-d1e2087"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "d14be04baee4e-d1e2087"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106915_epub_chap017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Seventeen")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "d14be04baee4e-d1e2236"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "d14be04baee4e-d1e2236"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106915_epub_chap018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Eighteen")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "d14be04baee4e-d1e2279"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "d14be04baee4e-d1e2279"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106915_epub_chap019",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Nineteen")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "d14be04baee4e-d1e2355"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "d14be04baee4e-d1e2355"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106915_epub_chap020",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "d14be04baee4e-d1e2537"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "d14be04baee4e-d1e2537"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106915_epub_chap021",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-One")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "d14be04baee4e-d1e2746"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "d14be04baee4e-d1e2746"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106915_epub_chap022",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-Two")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "d14be04baee4e-d1e3026"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "d14be04baee4e-d1e3026"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106915_epub_chap023",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-Three")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "d14be04baee4e-d1e3235"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "d14be04baee4e-d1e3235"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106915_epub_chap024",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-Four")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "d14be04baee4e-d1e3580"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "d14be04baee4e-d1e3580"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106915_epub_chap025",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-Five")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "d14be04baee4e-d1e3724"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "d14be04baee4e-d1e3724"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106915_epub_chap026",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6859a4be","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9781780106915_epub_itoc.vue
// module id = 60
// module chunks = 0